import { render, staticRenderFns } from "./SendAskOpinion.vue?vue&type=template&id=9bf86550&scoped=true&"
import script from "./SendAskOpinion.vue?vue&type=script&lang=ts&"
export * from "./SendAskOpinion.vue?vue&type=script&lang=ts&"
import style0 from "./SendAskOpinion.vue?vue&type=style&index=0&id=9bf86550&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf86550",
  null
  
)

export default component.exports